import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaSpotify,
  FaMusic,
} from "react-icons/fa";
import Logo from "../assets/logo1.png"; // Assuming you have a logo image in the assets folder

const Footer = () => {
  return (
    <div className="custom-footer">
      <div className="footer-clip">
        <div className="container is-fluid">
          <div className="columns is-variable is-6 is-multiline has-text-white is-flex is-align-items-center is-justify-content-center">
            {/* Left Column: Logo + Office Info Side by Side */}
            <div className="column is-12-mobile is-4-tablet is-footer-gap">
              <div className="is-flex is-align-items-start is-gap-3">
                {/* Logo */}
                <figure
                  className="image is-96x96 mr-4 is-flex is-flex is-align-items-center is-justify-content-center mr-5"
                  style={{ backgroundColor: "white", borderRadius: "20%" }}
                >
                  <img src={Logo} alt="Logo" />
                </figure>

                {/* Office Info */}
                <div>
                  <p>
                    <strong className="cust-text-white">Office Hours:</strong>{" "}
                    Monday - Thursday
                    <br />
                    9am - 4pm
                  </p>
                  <p>
                    <strong className="cust-text-white">Address:</strong>{" "}
                    Namchi, Sikkim, 77802
                  </p>
                </div>
              </div>
            </div>

            {/* Center Column: Social Icons */}
            <div className="column is-12-mobile is-4-tablet has-text-centered  is-flex is-align-items-end is-justify-content-center is-footer-gap">
              <div className="is-flex is-justify-content-center is-align-items-center is-flex-wrap-wrap social-icons">
                <FaFacebookF />
                <FaInstagram />
                <FaYoutube />
                <FaSpotify />
                <FaMusic />
              </div>
            </div>

            {/* Right Column: Contact Info */}
            <div className="column is-12-mobile is-4-tablet is-footer-gap">
              <p>
                <strong className="cust-text-white">Contact Us</strong>
              </p>
              <p>
                <a href="#">connect@apostoliccommunity@gmail.com</a>
              </p>
              <p>
                <a href="tel:+917005821927">7005821927</a>
              </p>
            </div>
            <div className="column is-12-mobile is-4-tablet is-flex is-justify-content-center">
              <p>
                Design and Developed with{" "}
                <span style={{ color: "red" }}>❤️</span> by Saino Solutions
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
